import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { IBcContestStudent } from '../../../models/BcContest';
import { BcContestService } from '../../../services/bc-contest.service';

@Component({
    templateUrl: './bc-contest-student-edit.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestStudentEditComponent {
    constructor(
        private service: BcContestService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set data(value: IBcContestStudent) {
        this._student = value;
        this.customGrade = value.CustomGrade;
    }

    customGrade: number;
    isSaving: boolean;

    get student() {
        return this._student;
    }

    private _student: IBcContestStudent;

    save() {
        this.isSaving = true;

        setTimeout(() => {
            this.service.updateStudent(this.student.Id, {
                customGrade: this.customGrade
            }).pipe(finalize(() => {
                this.isSaving = false;
            })).subscribe(data => {
                this.student.CustomGrade = this.customGrade;
                this.activeModal.close();
            });
        }, 500);
    }

    close() {
        this.activeModal.dismiss();
    }
}
